module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=GF - French Guiana.29c418e6.svg";